class SingleMap {
	constructor() {
		// view
		this.cname = ".single-map";
		this.components = document.querySelectorAll(this.cname);
		this.map = null;
		this.mapZoom = 10;

		if (this.components) {
			this.init();
		}
	}

	init() {
		this.components.forEach( map => {
			let options = {
				id: map.id,
				zoom: this.mapZoom,
				mapTypeId: 'roadmap',
				maxZoom: this.mapZoom,
				infoBubble: true,
				infoBubbleOptions: {
					arrowPosition: 50,
					shadowStyle: 0
				},
				offset: { x: 0, y: 0 },
				mapOptions: {
					zoomControl: true,
					zoomControlOptions: { position: 7 },
					scrollwheel: false,
					streetViewControl: false,
					fullscreenControl: false,
					styles: "",
				},
				label: {
					color: 'white',
					hover_color: 'black'
				},
				lat: 40.7457331,
				lng: -73.9979199,
				mobileZoom: 6,
				active_markers: false,
				infoBubbleContent: this.infoBubbleContent,
				onMarkerClicked: this.onMarkerClicked,
			}

			const locations = window['locations_' + map.dataset.id];

			if(gmapsFired){
				this.map = new mapED(locations, options);
			} else {
				document.addEventListener('gmapsLoaded', (e) => {
					this.map = new mapED(locations, options);
				});
			}
			
		});
	}
}

document.addEventListener('DOMContentLoaded', function () {
	new SingleMap();
});
